<template>
    <div>
        <div class="list-item mt-3" v-for="(item, index) in value" :key="item.id">
            <div>
                <div class="form-group mr-1">
                    <select class="form-control" v-model="item.lubricant_id" @change="changed">
                        <option v-for="lubricant in lubricants" :key="lubricant.id" :value="lubricant.id">{{lubricant.title}}</option>
                    </select>
                </div>
            </div>
            <div>
                <div class="input-group" style="width:90px;">
                    <div class="input-group-prepend">
                        <span class="input-group-text">L</span>
                    </div>
                    <vue-numeric separator="," v-model="item.liters" @change="changed" class="form-control text-right" :precision="2" ></vue-numeric>
                </div>
            </div>
            <div class="btn" @click="remove(index)"><i class="icon icon-sm icon-close"></i></div>
        </div>
        <div class="btn btn-sm btn-success pull-right mt-4"  @click="newItem()">Agregar lubricante</div>
    </div>
</template>

<script>

export default {
    name: "LubricantsInput",
    props:{
        value:{
            type: Array,
            default: () => ([])
        }
    },
    data () {
        return {
            lubricants:[
				{ id: 1, title: 'Aceite de motor Nafta', price: '84'},
				{ id: 2, title: 'Aceite de motor Diesel', price: '73'},
				{ id: 3, title: 'Liquido de caja de cambios', price: '45'},
				{ id: 4, title: 'Liquido de diferencial', price: '14'},
            ],
        }
    },
    methods:{
        selectLubricant(){

        },
        newItem(){
            this.value.push({lubricant_id: null, liters: 0})
        },
        remove(index){
            this.value.splice(index,1)
        },
        changed(){
            this.$emit('input',this.value)
            // this.$emit('changed')
        }
    }

}
</script>

<style lang="scss" scoped>
.list-item{
    margin:4px 0px;
    display: flex;

     > div:first-child{
        flex-grow: 1;
    }
}
</style>